import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, tap } from 'rxjs';
import { ProposalActions } from './proposal.actions';

@Injectable({
  providedIn: 'root'
})
export class ProposalEffects {
  sendProposalEffect$: Observable<Action>;

  constructor(private actions$: Actions) {
    this.sendProposalEffect$ = createEffect(
      (): any =>
        this.actions$.pipe(
          ofType(ProposalActions.submitSuccess),
          tap(() => {})
        ),
      { dispatch: false }
    );
  }
}
